export * from './age-restrictions';
export * from './aria';
export * from './calculations';
export * from './content';
export * from './dispensaries';
export * from './ernie';
export * from './forms';
export * from './orders';
export * from './products';
export * from './pusher';
export * from './specials';
export * from './taxes';
export * from './time';

export const DELIVERY = 'Delivery';
export const PICKUP = 'Pickup';

export const ORDER_TYPE_CURBSIDE_PICKUP = 'curbsidePickup';
export const ORDER_TYPE_DRIVE_THRU_PICKUP = 'driveThruPickup';
export const ORDER_TYPE_IN_STORE_PICKUP = 'inStorePickup';
export const MENU_TYPE_REC = 'rec';
export const MENU_TYPE_MED = 'med';

/**
 * Maps lowercase menu type to uppercase enum value
 * @param {string} menuType - The menu type ('rec' or 'med')
 * @returns {string} Uppercase menu type ('REC' or 'MED'), defaults to 'REC'
 */
export const toUppercaseMenuType = (menuType) => {
  if (menuType === MENU_TYPE_MED) {
    return 'MED';
  }
  return 'REC';
};

export const logoPlaceholder = 'https://s3-us-west-2.amazonaws.com/dutchie-images/logo-placeholder.png';

export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiZHV0Y2hpZS1lbmciLCJhIjoiY2tkNjlxaGNlMG51ajJ4bzhjbTk5cG5zNyJ9.FEj8yCJEq36aac-v-N227w';

export const DUTCHIE_IFRAME_ID = 'dutchie--embed__iframe';

export const DUTCHIE_MAIN_STORED_CART_KEY = 'dutchieMain';
export const LOCAL_STORAGE_STORED_CART_KEY = 'stored-cart';
export const MOST_RECENT_DISPO_KEY = 'mostRecentDispo';

export const NUMERALS_DOLLAR_FORMAT = '$0,0.00';

export const DEFAULT_INPUT_MAX_LENGTH = 100;
